import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, DataTable, Section, Loading, KPITile } from "../components/Common";

export default function Boarding() {
  const [houses, setHouses] = useState(null);
  const [boarders, setBoarders] = useState([]);
  useEffect(() => {
    api.boardingHouses().then(({ data }) => setHouses(data));
    api.boardingStudents().then(({ data }) => setBoarders(data));
  }, []);
  if (houses === null) return <Loading />;
  const total = houses.reduce((a, h) => a + h.occupancy, 0);
  const cap = houses.reduce((a, h) => a + h.capacity, 0);
  return (
    <div data-testid="boarding-page">
      <PageHeader kicker="Boarding" title="Boarding Houses" subtitle="Pastoral care and residential life." />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <KPITile tone="dark" testId="bd-total" label="Boarders" value={total} sub={`of ${cap} capacity`} />
        <KPITile testId="bd-houses" label="Houses" value={houses.length} />
        <KPITile testId="bd-occupancy" label="Occupancy" value={cap > 0 ? `${Math.round(total / cap * 100)}%` : "—"} />
        <KPITile testId="bd-boys" label="Boys Houses" value={houses.filter((h) => (h.gender || "").toLowerCase() === "boys").length} />
      </div>
      <Section title="Houses">
        <DataTable
          columns={[
            { key: "name", label: "House" },
            { key: "gender", label: "Gender" },
            { key: "occupancy", label: "Occupancy" },
            { key: "capacity", label: "Capacity" },
            { key: "util", label: "Utilisation", render: (r) => `${Math.round(r.occupancy / r.capacity * 100)}%` },
          ]}
          rows={houses}
        />
      </Section>
      <Section title={`Boarding students (${boarders.length})`}>
        <DataTable
          columns={[
            { key: "name", label: "Student", render: (r) => `${r.first_name} ${r.last_name}` },
            { key: "year_group", label: "Year" },
            { key: "house", label: "House" },
            { key: "nationality", label: "Nationality" },
          ]}
          rows={boarders.slice(0, 100)}
        />
      </Section>
    </div>
  );
}
